import React from 'react';
import { Tag, Typography } from 'antd';
import { camelCaseToTitle } from "../../helpers/StringHelper";

const { Text } = Typography;

export const renderStatus = (t, record, notOneHunderdPercent = false) => (
  <Tag
    className="status-tag"
    style={{ width: !notOneHunderdPercent && '100%', textAlign: 'center' }}
    color={record === 'unplanned' ? 'default' : 'blue'}
  >
    <Text ellipsis={{ tooltip: true }}>
      {t(camelCaseToTitle(record))}
    </Text>
  </Tag>
);

export const renderObjective = (t, record) => (
  <Tag className="objective-tag" color={record === 'reduceVulnerability' ? 'blue' : 'default'}>
    <Text
      className="ellipsis-span"
      style={{ width: 'calc(100%)' }}
      ellipsis={{ tooltip: t(record) }}
    >
      {t(record)}
    </Text>
  </Tag>
);
